// device Access Service - for unlocking devices and viewing history

import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const fetchSockets = async () => {
    try {
        const res = await apiFetch(`${API_BASE}/sockets/available`);
        if (!res.ok) throw new Error("Не вдалося завантажити сокети");
        return await res.json();
    } catch (error) {
        console.error("fetchSockets error:", error);
        throw error;
    }
};

export const unlockDevice = async (socketId, code = "") => {
    try {
        const res = await apiFetch(`${API_BASE}/sockets/${socketId}/unlock`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(code ? { code } : {}),
        });

        const data = await res.json();

        if (!res.ok) {
            throw new Error(data.detail || "Не вдалося відкрити двері");
        }
        return data;
    } catch (error) {
        console.error("unlockDevice error:", error);
        throw error;
    }
};

export const fetchUnlockHistory = async ({ dateFrom, dateTo } = {}) => {
    try {
        const params = new URLSearchParams();
        if (dateFrom) params.set("date_from", dateFrom);
        if (dateTo) params.set("date_to", dateTo);
        const qs = params.toString();

        const res = await apiFetch(`${API_BASE}/sockets/history${qs ? `?${qs}` : ""}`);
        if (!res.ok) throw new Error("Не вдалося завантажити історію");
        return await res.json();
    } catch (error) {
        console.error("fetchUnlockHistory error:", error);
        throw error;
    }
};

